import { render, staticRenderFns } from "./VxInputGroup.vue?vue&type=template&id=cb09f186&functional=true&"
import script from "./VxInputGroup.vue?vue&type=script&lang=js&"
export * from "./VxInputGroup.vue?vue&type=script&lang=js&"
import style0 from "./VxInputGroup.vue?vue&type=style&index=0&id=cb09f186&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports